<div
  class="border-dashed border-2 rounded-xl p-10 flex flex-col items-center justify-center transition-colors cursor-pointer outline-none focus:ring-2 focus:ring-brand-9 focus:border-brand-9"
  [class.border-gray-5]="!isDragOver"
  [class.border-brand-9]="isDragOver"
  [class.bg-brand-2]="isDragOver"
  tabindex="0"
  role="button"
  aria-label="Zone de dépôt de photos. Cliquez ou appuyez sur Entrée pour parcourir vos fichiers."
  (click)="fileInput.click()"
  (keydown.enter)="fileInput.click()"
  (keydown.space)="$event.preventDefault(); fileInput.click()"
>
  <div class="mb-4 text-gray-11">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
      <circle cx="12" cy="13" r="3" />
    </svg>
  </div>
  <h3 class="text-xl font-medium text-gray-12 mb-2">Glissez-déposez vos photos</h3>
  <p class="text-sm text-gray-11 mb-6">ou recherchez des photos</p>

  <button mat-button tabindex="-1" class="primary">Parcourir</button>

  <input
    #fileInput
    type="file"
    multiple
    accept="image/*"
    class="hidden"
    (change)="onFileSelected($event)"
    aria-label="Importer des photos"
  />
</div>
